/**
 * main.tsx — entry point
 *
 * JSON-LD schema blocks live directly in index.html <head> (preserved through
 * Vite build + prerender). No runtime injection here.
 *
 * Hydrates the prerendered React tree wrapped in BrowserRouter. Falls back
 * to createRoot in dev if no SSR markup is present.
 */
import { createRoot, hydrateRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.tsx";
import "./index.css";

const rootEl = document.getElementById("root")!;

const tree = (
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

const prerenderPath = rootEl.getAttribute("data-prerender-path");
const normalizedPath = window.location.pathname.replace(/\/$/, "") || "/";

if (rootEl.hasChildNodes() && prerenderPath === normalizedPath) {
  hydrateRoot(rootEl, tree);
} else {
  rootEl.innerHTML = "";
  createRoot(rootEl).render(tree);
}
